import React, { Component } from 'react';
import {connect} from 'react-redux';
import withRouter from 'react-router-dom/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { sendMetrics, setMetricsEvent } from 'src/actions/metrics';
import { Team } from 'src/mundial/requests/interfaces';
import Asset from 'src/requests/apa/Asset';
import Utils from 'src/utils/Utils';
import logger from 'src/utils/logger/logger';
import './_styles.scss';

interface IProps {
    team: Team;
    history: any;
    id: string;
    withRibbonTitle?: boolean;
    upFocus?: string;
    leftFocus?: string;
    rightFocus?: string;
    row: number;
    parentComponent: string;
}

class TeamCard extends Component<IProps> {
    team: Team;

    constructor(props: Readonly<IProps>) {
        super(props);
        this.team = props.team;
        this.handleOnClick = this.handleOnClick.bind(this)
        this.onFocus = this.onFocus.bind(this);
    }

    handleOnClick() {
        Utils.sendMetric(this.props, "grupos", this.team.name, 'mundial 2022');
        const { history } = this.props;
        history.push(`/mundial/vcard-equipo/${this.team.id}`);
    }

    onFocus(row: number, parentComponent: string) {
        let container;
        let height = 0;
        if(parentComponent === "groups") {
            container = document.querySelector(".container-groups");
            height = 305;
        }
        if(parentComponent === "teams") {
            container = document.querySelector(".container-teams");
            height = 248
        }
        logger.debug("@@@@@@@ CONTAINER:", container)
        if(container){
            container.scrollTop = row * height;
        }
    }

    render() {
        const row = this.props.row;
        const parentComponent = this.props.parentComponent;
        return (
            <a onClick={this.handleOnClick}
                className="focusable team-card-container"
                href="javascript:void(0)"
                tabIndex={0}
                id={this.props.id}
                data-sn-up={this.props.upFocus}
                data-sn-left={this.props.leftFocus}
                data-sn-right={this.props.rightFocus}
                onFocus={(e) => this.onFocus(row, parentComponent)}
                >
                <div
                    className={`team-card ${this.props.withRibbonTitle ? "with-ribbon-title" : ""}`}
                    >
                        <div className="team-image-container">
                            <img className="team-image" width="102" height="102" src={this.team.logo || Asset.get("ribbon_team_placeholder_img", "")} alt={this.team.name}/>
                        </div>
                        <p className="team-name">{this.team.name}</p>
                    </div>
            </a>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
    bindActionCreators(
        {
            setMetricsEvent,
        },
        dispatch
    );
export default connect(null, mapDispatchToProps)(withRouter(TeamCard));



// WEBPACK FOOTER //
// ./src/mundial/Home/TeamCard/index.tsx